import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ManageProductsEdit } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetMyAccountProductDetail } from '@services/useGetMyAccountProductDetail';

export function ManageProductsEditPage() {
    const { myAccountProductDetail } = useData();
    const { request: requestMyAccountProductDetail } = useGetMyAccountProductDetail();
    const { uuid } = useParams();
    const { t, i18n } = useTranslation();

    // fetch product detail info
    useEffect(() => {
        requestMyAccountProductDetail({ uuid: uuid || '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid, i18n.language]);

    const translations = {
        title: t('manage-products-edit-component.metatags.title', { name: myAccountProductDetail?.data?.product?.name }),
        description: t('manage-products-edit-component.metatags.description', {
            name: myAccountProductDetail?.data?.product?.name,
        }),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myProductsEdit.replace(':uuid', `${uuid}`),
        index: false,
    });

    return <ManageProductsEdit />;
}
